<template>
    <div class="lg:px-0 lg:py-0 flex flex-col items-center justify-center h-full px-4 py-10">
        <h4 class="m-y-md text-center">{{ $t('auth.wrong_invitation_link') }}</h4>
        <p class="pb-6 text-center">{{ $t('auth.wrong_invitation_link_details') }}</p>
        <p class="pb-4 text-center" v-html="$t('auth.wrong_invitation_link_info_line', {
            linkOpen: '<a href=&quot;/sign-up&quot;>',
            linkClose: '</a>',
        })"></p>
        <div class="md:w-1/4 w-1/2 pb-10">
            <svg-warning></svg-warning>
        </div>
    </div>
</template>

<script>
import SvgWarning from '../../../../svg/warning.vue';

export default {
    components: {
        'svg-warning': SvgWarning,
    },
};
</script>
